import bathroom from "../../../assets/images/background/home/bathroom.png";
import bedroom from "../../../assets/images/background/home/bedroom.png";
import dinnerRoom from "../../../assets/images/background/home/dinner_room.png";
import floor from "../../../assets/images/background/home/floor.png";
import floorArmchairs from "../../../assets/images/background/home/floor_armchairs.png";
import floorCorner from "../../../assets/images/background/home/floor_corner.png";
import floorCross from "../../../assets/images/background/home/floor_cross.png";
import floorHall from "../../../assets/images/background/home/floor_hall.png";
import floorStraight from "../../../assets/images/background/home/floor_straight.png";
import floorT from "../../../assets/images/background/home/floor_t.png";
import floorTable from "../../../assets/images/background/home/floor_table.png";
import floorUp from "../../../assets/images/background/home/floor_up.png";
import floorUpRight from "../../../assets/images/background/home/floor_up_right.png";
import grass from "../../../assets/images/background/home/grass.png";
import kidsRoom from "../../../assets/images/background/home/kids_room.png";
import kitchen from "../../../assets/images/background/home/kitchen.png";
import masterBedroom from "../../../assets/images/background/home/master_bedroom.png";
import photovoltaic from "../../../assets/images/background/home/photovoltaic.png";
import pool from "../../../assets/images/background/home/pool.png";
import start from "../../../assets/images/background/home/start.png";
import tvRoom from "../../../assets/images/background/home/tv_room.png";
import yard from "../../../assets/images/background/home/yard.png";
import yardCorner from "../../../assets/images/background/home/yard_corner.png";
import yardDoor from "../../../assets/images/background/home/yard_door.png";

// Reusable Wall Patterns 
const WALLS = {
	EMPTY: [],
	STANDARD_ROOM: [
		{ x1: 32, y1: 0, x2: 0, y2: 0 },
		{ x1: 0, y1: 0, x2: 0, y2: 100 },
		{ x1: 0, y1: 100, x2: 100, y2: 100 },
		{ x1: 100, y1: 100, x2: 100, y2: 0 },
		{ x1: 100, y1: 0, x2: 68, y2: 0 },
	],
	BOTTOM_GATE: [ // Used for Start and Yard Door
		{ x1: 0, y1: 69, x2: 32, y2: 69 },
		{ x1: 32, y1: 69, x2: 32, y2: 100 },
		{ x1: 68, y1: 100, x2: 68, y2: 69 },
		{ x1: 68, y1: 69, x2: 100, y2: 69 },
	],
	SINGLE_BOTTOM: [
		{ x1: 0, y1: 69, x2: 100, y2: 69 },
	],
};

// Reusable POI Patterns 
const POIS = {
	NONE: { name: "", items: [] },
	ROOM_STANDARD: {
		name: "room",
		items: [{ x: 50, y: 15 }]
	},
	FLOOR_CENTER: {
		name: "floor",
		items: [{ x: 50, y: 50 }]
	},
};

// Function to Create Components 
const create = (id, image, text, pois, walls = WALLS.EMPTY, waters = []) => ({
	id,
	image,
	text,
	pois,
	walls,
	waters,
});

const home = {
	name: "Home",
	components: {
		bathroom: create("bathroom", bathroom, "Bathroom", POIS.ROOM_STANDARD, WALLS.STANDARD_ROOM),
		bedroom: create("bedroom", bedroom, "Bedroom", POIS.ROOM_STANDARD, WALLS.STANDARD_ROOM),
		dinnerRoom: create("dinnerRoom", dinnerRoom, "Dinner Room", POIS.ROOM_STANDARD, WALLS.STANDARD_ROOM),
		kidsRoom: create("kidsRoom", kidsRoom, "Kids Room", POIS.ROOM_STANDARD, WALLS.STANDARD_ROOM),
		kitchen: create("kitchen", kitchen, "Kitchen", POIS.ROOM_STANDARD, WALLS.STANDARD_ROOM),
		masterBedroom: create("masterBedroom", masterBedroom, "Master Bedroom", POIS.ROOM_STANDARD, WALLS.STANDARD_ROOM),
		tvRoom: create("tvRoom", tvRoom, "Tv Room", POIS.ROOM_STANDARD, WALLS.STANDARD_ROOM),

		floor: create("floor", floor, "Floor", POIS.FLOOR_CENTER),
		floorStraight: create("floorStraight", floorStraight, "Floor Straight", POIS.FLOOR_CENTER, [
			{ x1: 0, y1: 31, x2: 100, y2: 31 },
			{ x1: 0, y1: 69, x2: 100, y2: 69 },
		]),
		floorT: create("floorT", floorT, "Floor T", POIS.FLOOR_CENTER, [
			{ x1: 32, y1: 0, x2: 32, y2: 31 },
			{ x1: 32, y1: 31, x2: 0, y2: 31 },
			{ x1: 0, y1: 69, x2: 100, y2: 69 },
			{ x1: 100, y1: 31, x2: 68, y2: 31 },
			{ x1: 68, y1: 31, x2: 68, y2: 0 },
		]),
		floorTable: create("floorTable", floorTable, "Floor Table", POIS.FLOOR_CENTER, [
			{ x1: 8, y1: 52, x2: 8, y2: 92 },
			{ x1: 8, y1: 92, x2: 53, y2: 92 },
			{ x1: 53, y1: 92, x2: 53, y2: 52 },
			{ x1: 53, y1: 52, x2: 8, y2: 52 },
			{ x1: 73, y1: 6, x2: 73, y2: 26 },
			{ x1: 73, y1: 26, x2: 94, y2: 26 },
			{ x1: 94, y1: 26, x2: 94, y2: 6 },
			{ x1: 94, y1: 6, x2: 73, y2: 6 },
		]),

		floorArmchairs: create("floorArmchairs", floorArmchairs, "Floor with Armchairs",
			{ name: "floor", items: [{ x: 75, y: 50 }] },
			[
				{ x1: 8, y1: 3, x2: 8, y2: 95 },
				{ x1: 8, y1: 95, x2: 50, y2: 95 },
				{ x1: 50, y1: 95, x2: 50, y2: 3 },
				{ x1: 50, y1: 3, x2: 8, y2: 3 },
			]
		),
		floorCorner: create("floorCorner", floorCorner, "Floor Corner",
			{ name: "floor", items: [{ x: 50, y: 17 }, { x: 50, y: 50 }, { x: 83, y: 50 }] },
			[
				{ x1: 32, y1: 0, x2: 32, y2: 69 },
				{ x1: 32, y1: 69, x2: 100, y2: 69 },
				{ x1: 100, y1: 31, x2: 68, y2: 31 },
				{ x1: 68, y1: 31, x2: 68, y2: 0 },
			]
		),
		floorCross: create("floorCross", floorCross, "Floor Cross",
			{ name: "floor", items: [{ x: 50, y: 17 }, { x: 50, y: 50 }, { x: 50, y: 83 }, { x: 17, y: 50 }, { x: 83, y: 50 }] },
			[
				{ x1: 32, y1: 0, x2: 32, y2: 31 },
				{ x1: 32, y1: 31, x2: 0, y2: 31 },
				{ x1: 0, y1: 69, x2: 32, y2: 69 },
				{ x1: 32, y1: 69, x2: 32, y2: 100 },
				{ x1: 68, y1: 100, x2: 68, y2: 69 },
				{ x1: 68, y1: 69, x2: 100, y2: 69 },
				{ x1: 100, y1: 31, x2: 68, y2: 31 },
				{ x1: 68, y1: 31, x2: 68, y2: 0 },
			]
		),
		floorHall: create("floorHall", floorHall, "Floor Hall",
			{ name: "floor", items: [{ x: 17, y: 50 }, { x: 83, y: 50 }] },
			[
				{ x1: 32, y1: 0, x2: 32, y2: 31 },
				{ x1: 32, y1: 31, x2: 0, y2: 31 },
				{ x1: 0, y1: 69, x2: 32, y2: 69 },
				{ x1: 32, y1: 69, x2: 32, y2: 100 },
			]
		),
		floorUp: create("floorUp", floorUp, "Floor Up Wall",
			{ name: "floor", items: [{ x: 50, y: 25 }] },
			WALLS.SINGLE_BOTTOM
		),
		floorUpRight: create("floorUpRight", floorUpRight, "Floor Up Right Walls",
			{ name: "floor", items: [{ x: 25, y: 25 }] },
			[
				{ x1: 0, y1: 69, x2: 68, y2: 69 },
				{ x1: 68, y1: 69, x2: 68, y2: 0 },
			]
		),

		grass: create("grass", grass, "Grass", POIS.NONE),
		photovoltaic: create("photovoltaic", photovoltaic, "Photovoltaic", POIS.NONE),
		pool: create("pool", pool, "Pool", POIS.NONE, WALLS.EMPTY, [{ x: 60, y: 46, range: 15 }]),

		yard: create("yard", yard, "Yard", POIS.NONE, WALLS.SINGLE_BOTTOM),
		yardCorner: create("yardCorner", yardCorner, "Yard Corner", POIS.NONE, [
			{ x1: 0, y1: 69, x2: 32, y2: 69 },
			{ x1: 32, y1: 69, x2: 32, y2: 100 },
		]),
		yardDoor: create("yardDoor", yardDoor, "Yard Door",
			{ name: "yard", items: [{ x: 50, y: 80 }] },
			WALLS.BOTTOM_GATE
		),

		start: create("start", start, "Start",
			{ name: "start", items: [{ x: 50, y: 80 }] },
			WALLS.BOTTOM_GATE
		),
	},
};

export default home;